module.exports = "/_next/static/images/Clock@2x-4344dc71dd4844c5380256e7b3af088b.png";